import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { tag } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.ul) `
  --bgColour: ${brand.primary.black};
  --fgColour: ${brand.primary.white};

  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
const Tag = styled.li `
  ${tag};

  background-color: var(--bgColour);
  color: var(--fgColour);
  margin: 0;
  padding: 6px ${fluid(8, 12)};
  border-radius: ${fluid(4, 8)};
`;
const CategoryTagsStyles = {
    Container,
    Tag,
};
export default CategoryTagsStyles;
